/* eslint-disable @typescript-eslint/naming-convention */
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IHttpBasicResponse } from '@boxx/core';

export interface IEventsRepository {
  getEvents(): Observable<IHttpBasicResponse<IEventsApiProps[]>>;
  createEvent(
    payload: IUpsertEventPayload
  ): Observable<IHttpBasicResponse<IEventsApiProps>>;
  updateEvent(
    id: number,
    payload: IUpsertEventPayload
  ): Observable<IHttpBasicResponse<IEventsApiProps>>;
  deleteEvent(payload: number): Observable<IHttpBasicResponse<null>>;
}

export const EVENTS_REPOSITORY = new InjectionToken<IEventsRepository>(
  'eventsRepository'
);

export interface IUpsertEventPayload {
  attendees?: {
    contact_id: string;
  }[];
  datetime_from: string;
  datetime_to: string;
  description?: string;
  latitude?: string;
  longitude?: string;
  place?: string;
  title: string;
  url?: string;
}

export interface IEventsApiProps extends IEventsCommonProps {
  client_id: string;
  id: string;
}

export interface IEventsCommonProps {
  attendees: Array<{
    contact_id?: string;
    email?: string;
    full_name?: string;
    initials: string;
    last_name: string;
    name: string;
    phone?: string;
  }>;

  datetime_from: string;
  datetime_to: string;
  description: string;

  latitude: string;
  longitude: string;
  place: string;
  title: string;
  url?: string;
}

export interface IEventReminder {
  id: number;
  title: string;
  text: string;
  date: Date;
}

export interface IEventFormProps {
  title: string;
  place: string;
  datetime_from: string;
  datetime_to: string;
  attendees: Array<{ contact_id: number }>;
  description: string;
  latitude: string;
  longitude: string;
  url?: string;
}
